module.exports = __webpack_public_path__ + "fonts/fa-regular-400.5632c43.woff2";